import * as React from 'react';
import { BulletWrapper } from '../ProjectOverviewStyles';
import { language } from '../ProjectOverviewLanguage';

export type Props = {
	bullet: any;
};

export const BulletLayout = (props: Props) => {
	const render = () => {
		const returnValue = <BulletWrapper>{props.bullet}</BulletWrapper>;
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
